import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NgxSpinnerService} from 'ngx-spinner';
import {CoreService} from '../../../Shared/Services/core.service';
import {SharedService} from '../../../Shared/Services/shared.service';
import {WindoRexVM} from "../../../Model/WindoRexVM";
import {InvitationsService} from "../../../Services/invitations.service";

@Component({
  selector: 'app-windo-rex',
  templateUrl: './windo-rex.component.html',
  styleUrl: './windo-rex.component.scss'
})
export class WindoRexComponent implements OnInit {
  formErrors: string[] = [];
  guestData: WindoRexVM = {} as WindoRexVM;
  options: any;
  form: FormGroup = new FormGroup({
    title: new FormControl('', [Validators.required]),
    workshopType: new FormControl('none', []),
    classification: new FormControl(null, []),
    fullName: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    state: new FormControl('', [Validators.required]),
    selectedState: new FormControl<{ 'state': string, 'citites': string[] } | null>(null, [Validators.required]),
    address: new FormControl('', [Validators.required]),
    workshop: new FormControl(null, []),
    email: new FormControl(null, [Validators.email]),
    phone: new FormControl('', [Validators.required]),
    message: new FormControl(null)
  });
  selectedState: { 'state': string, 'citites': string[] } = {} as { 'state': string, 'citites': string[] };
  governrates = [
    {
      "state": "محافظة القاهرة",
      "citites": [
        "القاهرة"
      ]
    },
    {
      "state": "محافظة الجيزة",
      "citites": [
        "الجِيزَة",
        "السادس من أكتوبر",
        "الشيخ زايد",
        "الحَوامْدِيّة",
        "البَدْرْشِين",
        "الصَّف",
        "أطْفِيح",
        "العَيَّاط",
        "الباويطي",
        "منشأة القناطر",
        "أَوْسِيم",
        "كِرْداسَة",
        "أبو النُمْرُس"
      ]
    },
    {
      "state": "محافظة القليوبية",
      "citites": [
        "بَنْها",
        "قَلْيوب",
        "شُبْرا الخيمة",
        "القناطر الخيرية",
        "الخْانْكَة",
        "كفر شُكر",
        "طُوخ",
        "قَها",
        "العبور",
        "الخُصُوص",
        "شِبِين القناطر"
      ]
    },
    {
      "state": "محافظة الإسكندرية",
      "citites": [
        "الإسكندرية",
        "برج العرب",
        "برج العرب الجديدة"
      ]
    },
    {
      "state": "محافظة البحيرة",
      "citites": [
        "دَمَنْهور",
        "كفر الدَّوَّار",
        "رَشيد",
        "إدكو",
        "أبو المطامير",
        "أبو حُمُّص",
        "الدِّلنْجات",
        "المحموديّة",
        "الرحمانيّة",
        "إيتاي البارود",
        "حُوش عيسى",
        "شُبراخِيت",
        "كوم حمادة",
        "بدر",
        "وادي النَطْرون",
        "النُوبَاريّة الجديدة"
      ]
    },
    {
      "state": "محافظة مطروح",
      "citites": [
        "مَرْسَى مَطْرُوح",
        "الحَمَّام",
        "العَلَمِين",
        "الضَّبْعَة",
        "النِّجِيلَة",
        "سِيِدي بَرَّانِي",
        "السَّلُّوم",
        "سِيوَة"
      ]
    },
    {
      "state": "محافظة دمياط",
      "citites": [
        "دمياط",
        "دمياط الجديدة",
        "رأس البر",
        "فارسكور",
        "كفر سعد",
        "الزرقا",
        "السرو",
        "الروضة",
        "كفر البطيخ",
        "عزبة البرج",
        "ميت أبو غالب"
      ]
    },
    {
      "state": "محافظة الدقهلية",
      "citites": [
        "المنصورة",
        "طَلْخا",
        "ميت غمر",
        "دِكِرِنْس",
        "أجا",
        "منية النصر",
        "السنبلاوين",
        "الكردي",
        "بني عبيد",
        "المنزلة",
        "تمي الأمديد",
        "الجمالية",
        "شربين",
        "المطرية",
        "بلقاس",
        "ميت سلسيل",
        "جمصة",
        "محلة دمنة",
        "نبروه"
      ]
    },
    {
      "state": "محافظة كفر الشيخ",
      "citites": [
        "كفر الشيخ",
        "دِسوق",
        "فُوّه",
        "مِطوُبِس",
        "بَلْطيم",
        "مصيف بَلْطيم",
        "الحامول",
        "بِيَلا",
        "الرياض",
        "سيدي سالم",
        "قَلّين",
        "سيدي غازي",
        "بُرج البُرلُّس",
        "مِسِير"
      ]
    },
    {
      "state": "محافظة الغربية",
      "citites": [
        "طنْطَا",
        "المحلة الكبرى",
        "كفر الزَّيَّات",
        "زِفْتى",
        "السّنْطة",
        "قُطور",
        "بَسْيون",
        "سَمَنُّود"
      ]
    },
    {
      "state": "محافظة المنوفية",
      "citites": [
        "شِبين الكوم",
        "مدينة السادات",
        "مِنُوف",
        "سِرس الليَّان",
        "أَشْمُون",
        "الباجور",
        "قُوِيْسنا",
        "بركة السبع",
        "تَلَا",
        "الشهداء"
      ]
    },
    {
      "state": "محافظة الشرقية",
      "citites": [
        "الزقازيق",
        "العاشر من رمضان",
        "منيا القمح",
        "بِلْبيس",
        "مشتول السوق",
        "القنايات",
        "أبو حمّاد",
        "القُرين",
        "هِهْيا",
        "أبو كبير",
        "فاقوس",
        "الصالحية الجديدة",
        "الإبراهيمية",
        "ديرب نجم",
        "كفر صقر",
        "أولاد صقر",
        " الحسينية",
        "صان الحجر القبلية",
        "منشأة أبو عمر"
      ]
    },
    {
      "state": "محافظة بورسعيد",
      "citites": [
        "بورسعيد",
        "بورفؤاد"
      ]
    },
    {
      "state": "محافظة الإسماعيلية",
      "citites": [
        "الإسماعيلية",
        "فايد",
        "القنطرة شرق",
        "القنطرة غرب",
        "التل الكبير",
        "أبو صوير المحطة",
        "القصاصين الجديدة"
      ]
    },
    {
      "state": "محافظة السويس",
      "citites": [
        "السويس"
      ]
    },
    {
      "state": "محافظة شمال سيناء",
      "citites": [
        "العريش",
        "الشّيخ زُوَيِّد",
        "رَفَح",
        "بئر العبد",
        "الحَسَنَة",
        "نَخِل"
      ]
    },
    {
      "state": "محافظة جنوب سيناء",
      "citites": [
        "الطور",
        "شرم الشيخ",
        "دهب",
        "نويبع",
        "طابا",
        "سانت كاترين",
        "أبو رديس",
        "أبو زنيمة",
        "رأس سدر"
      ]
    },
    {
      "state": "محافظة بني سويف",
      "citites": [
        "بني سويف",
        "بني سويف الجديدة",
        "الواسْطَى",
        "ناصر",
        "إهناسيا",
        "بِبا",
        "سمسطا",
        "الفَشْن"
      ]
    },
    {
      "state": "محافظة الفيوم",
      "citites": [
        "الفُيُّوم",
        "الفُيُّوم الجديدة",
        "طَامِيِّة",
        "سنورس",
        "إطسا",
        "إبشواي",
        "يوسف الصديق"
      ]
    },
    {
      "state": "محافظة المنيا",
      "citites": [
        "المنيا",
        "المنيا الجديدة",
        "العدوة",
        "مَغَاغَة",
        "بني مزار",
        "مَطَاي",
        "سَمَالُوط",
        "المدينة الفكرية",
        "مَلّوي",
        "دِير مَوَاس"
      ]
    },
    {
      "state": "محافظة أسيوط",
      "citites": [
        "أسيوط",
        "أسيوط الجديدة",
        "دَيْرُوط",
        "منفلوط",
        "القوصية",
        "أَبْنُوب",
        "أبو تيج",
        "الغنايم",
        "ساحل سليم",
        "البداري",
        "صِدفا"
      ]
    },
    {
      "state": "محافظة الوادي الجديد",
      "citites": [
        "الخَارْجَة",
        "باريس",
        "مُوط",
        "الفرافرة",
        "بلاط"
      ]
    },
    {
      "state": "محافظة البحر الأحمر",
      "citites": [
        "الغردقة",
        "رأس غارب",
        "سفاجا",
        "القصير",
        "مرسى علم",
        "الشلاتين",
        "حلايب"
      ]
    },
    {
      "state": "محافظة سوهاج",
      "citites": [
        "سُوهَاج",
        "سوهاج الجديدة",
        "أخميم",
        "أخميم الجديدة",
        "البلْيَنا",
        "المراغة",
        "المنشأة",
        "دار السلام",
        "جِرجا",
        "جُهِينَة الغربيّة",
        "ساقلتة",
        "طمَا",
        "طَهُطَا"
      ]
    },
    {
      "state": "محافظة قنا",
      "citites": [
        "قِنَا",
        "قنا الجديدة",
        "أبُو تِشْت",
        "نَجْع حَمَّادِي",
        "دِشْنَا",
        "الوَقْف",
        "قِفْط",
        "نَقَادَة",
        "قُوص",
        "فَرْشُوط"
      ]
    },
    {
      "state": "محافظة الأقصر",
      "citites": [
        "الأقصر",
        "الأقصر الجديدة",
        "طِيبة الجديدة",
        "الزينيّة",
        "البَيَاضِيّة",
        "القُرْنَة",
        "أَرمَنْت",
        "الطُّود",
        "إسنا"
      ]
    },
    {
      "state": "محافظة أسوان",
      "citites": [
        "أَسْوان",
        "أَسْوان الجديدة",
        "دراو",
        "كُوم أُمْبُو",
        "نصر النوبة",
        "كَلَابْشَة",
        "إِدفو",
        "الرِّدِيسيّة",
        "البِصِيليَّة",
        "السباعية",
        "أبو سمبل السياحية"
      ]
    }
  ];
  titles: { 'text': string, 'value': string }[] = [
    {text: 'بدون لقب', value: 'بدون لقب'},
    {text: 'المهندس', value: 'المهندس'},
    {text: 'الدكتور', value: 'الدكتور'},
    {text: 'الحاج', value: 'الحاج'},
    {text: 'الأستاذ', value: 'الأستاذ'},
    {text: 'الأسطى', value: 'الأسطى'},
    {text: 'المعلم', value: 'المعلم'}
  ];

  workshopClassifications: { 'text': string, 'value': string }[] = [
    {text: 'ورشة', value: 'workshop'},
    {text: 'مصنع', value: 'factory'}
  ];
  workshopTypes: { 'text': string, 'value': string }[] = [
    {text: 'ليس لدي ورشة او مصنع', value: 'none'},
    {text: 'بي في سي', value: 'pvc'},
    {text: 'الوميتال', value: 'aluminium'},
    {text: 'بي في سي و الوميتال', value: 'both'},
    {text: 'غير ذلك', value: 'other'}
  ]

  constructor(private settings: CoreService, private api: InvitationsService, private router: Router,
              private translateService: TranslateService,
              private spinner: NgxSpinnerService, private shared: SharedService) {
    this.options = this.settings.getOptions();
  }

  ngOnInit() {
    this.form.controls['workshopType'].valueChanges.subscribe((value) => {
      if (value != 'none') {
        this.form.controls['workshop'].setValidators([Validators.required]);
        this.form.controls['classification'].setValidators([Validators.required]);
        if (!this.form.controls['classification'].value) {
          this.form.controls['classification'].setValue('workshop');
        }
      } else {
        this.form.controls['workshop'].setValidators([]);
        this.form.controls['classification'].setValidators([]);
        this.form.controls['classification'].setValue(null);
      }
      this.form.controls['workshop'].updateValueAndValidity();
      this.form.controls['classification'].updateValueAndValidity();
    });
  }


  get f() {
    return this.form.controls;
  }

  submit() {
    if (this.form.valid) {
      this.SumbitLogin(this.form.value);
    } else {
      this.shared.FireFormValidation(this.form);
    }
  }

  SumbitLogin(form: any) {
    this.spinner.show();
    this.formErrors = [];
    this.api.send(form).subscribe(
      {
        next: (data: any) => {
          this.spinner.hide();
          this.router.navigateByUrl('windorex/sent/' + data.id);
        },
        error: (error: any) => {
          this.spinner.hide();

        }
      }
    );

  }

  changeState(state: any) {
    this.form.controls['state'].setValue(state?.state ?? '');
    this.selectedState = state;
    this.form.controls['city'].setValue(state.citites.length > 1 || state.citites.length < 1 ? '' : state.citites[0]);
  }

  get Citites(): string[] {
    return this.selectedState?.citites ?? [];
  }

  get WorkshopLabel(): string {
    let current = this.f['classification'].value;
    if (!current) return this.translateService.instant(`windoRex.workshopName`);
    return this.translateService.instant(`windoRex.types.${current}Name`);
  }

  get WorkshopClassLabel(): string {
    let current = this.f['classification'].value;
    if (!current) return this.translateService.instant(`windoRex.workshopName`);
    return this.translateService.instant(`windoRex.types.${current}`);
  }

  get ShowWorkshopFields(): boolean {
    return this.f['workshopType'].value !== 'none';
  }

  changeClassification(classification: { text: string; value: string }) {
    this.form.controls['classification'].setValue(classification?.value ?? null);
  }
}
